<template lang='pug' src='./Nav-Mobile.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      isClicked: false
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    toggle () {
      this.links = !this.links
      this.isClicked = !this.isClicked
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// Nav-Mobile.vue?30a94c93